import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { useFormikContext } from "formik";

import { InputFormik } from "../../../common/components";

const DEFAULT_PROPS = {
  disabled: false,
  onChange: null,
};

export const StreetNumberField = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  const { values, setFieldValue, initialValues } = useFormikContext();

  //https://formik.org/docs/examples/dependent-fields
  useEffect(() => {
    const newValue = values.checkNumber
      ? "S/N"
      : initialValues.street_number || "";
    setFieldValue("street_number", newValue);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.checkNumber]);

  return (
    <>
      <InputFormik
        id="street_number"
        disabled={attrs.disabled || values.checkNumber}
        label="Número"
        margin="b-20"
        name="street_number"
        onChange={attrs.onChange}
      />
    </>
  );
};

StreetNumberField.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
